import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { ITransferApiListResponse, ITransferMutationResponse, ITransferUpdateParams } from '@/types/transfer';

export const transferList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ITransferApiListResponse>> => {
    return axios.get('/api/transfer/list', { ...config, params });
};

export const transferCreate = (params: ITransferUpdateParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ITransferMutationResponse>> => {
    return axios.post('/api/transfer/create', params, config);
};

export const transferUpdate = (params: ITransferUpdateParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ITransferMutationResponse>> => {
    return axios.post('/api/transfer/update', params, config);
};

export const transferDelete = (params: ITransferUpdateParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ITransferMutationResponse>> => {
    return axios.post('/api/transfer/delete', params, config);
};
